import type { EventContentObjectDetail } from 'models';
import { usePermissions } from 'permissions';
import { Button, Form, Icon } from 'ui';
import { EventInviteesFooter } from '../../event-invitees-footer';
import { EventInviteesFilters, type EventInviteesFiltersFormValues } from '../event-invitees-filters';
import { EventInviteesList } from '../event-invitees-list';

type FormValues = EventInviteesFiltersFormValues;

const initialValues: Partial<FormValues> = {
  role: 'all',
  status: 'all',
};

type P = {
  eventContentObject: EventContentObjectDetail;
  onOpenInviteModal?: () => void;
};

const EventInviteesForm = ({ eventContentObject, onOpenInviteModal }: P) => {
  const { goingInviteesCount, notGoingInviteesCount, pendingInviteesCount } = eventContentObject.event;
  const { canInviteRailsUserToEvent } = usePermissions();

  return (
    <Form<FormValues> initialValues={initialValues} layout="vertical">
      <EventInviteesFilters />

      <Form.Item<FormValues> dependencies={['search', 'role', 'status']} noStyle>
        {({ getFieldsValue }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const { role, search, status } = getFieldsValue(true) as Partial<FormValues>;

          return (
            <EventInviteesList
              eventContentObject={eventContentObject}
              filter={{
                role: role === 'all' ? undefined : role,
                search,
                status: status === 'all' ? undefined : status,
              }}
            />
          );
        }}
      </Form.Item>

      <EventInviteesFooter
        extra={
          onOpenInviteModal && canInviteRailsUserToEvent({ contentObject: eventContentObject }) ? (
            <Button
              icon={<Icon icon="user-add-line" />}
              onClick={() => {
                onOpenInviteModal();
              }}
              type="secondary"
            >
              Invite users
            </Button>
          ) : null
        }
        goingInviteesCount={goingInviteesCount}
        notGoingInviteesCount={notGoingInviteesCount}
        pendingInviteesCount={pendingInviteesCount}
      />
    </Form>
  );
};

export default EventInviteesForm;
